import { RouteObject } from "react-router-dom";
import { NotFound } from "src/routes/NotFound";
import { ConstraintItemCatalogPage } from "src/routes/libraries/task-catalog/ConstraintItemCatalogPage";
import { TaskCatalogLaborCostsPage } from "src/routes/libraries/task-catalog/TaskCatalogLaborCostsPage";
import { TaskCatalogPage } from "src/routes/libraries/task-catalog/TaskCatalogPage";
import { TaskCatalogForm } from "src/routes/libraries/task-catalog/components/TaskCatalogForm";
import { AppShell } from "src/routing/components/AppShell";
import { BeamNavbarLayout } from "src/routing/components/layouts/BeamNavbarLayout";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import * as taskCatalogPaths from "src/routing/domains/libraries/task-catalog/taskCatalogPaths";

/**
 * `/libraries/task-catalog/*` route tree.
 *
 * Role: data router domain route.
 *
 * Two layout stacks coexist during migration:
 * - **New (Beam):** `AppShell` → `BeamNavbarLayout` → `TaskCatalogPage` (index + folder views,
 *   using `PageHeaderLayout` / `GridTableLayout`)
 * - **Legacy:** `AppShell` → `GlobalNavLayout` → `ScrollableParentLayout` → page
 *   (form, constraint catalog, labor costs, still on legacy `PageHeader`)
 *
 * Folder views moved from `:folderId` to `folders/:folderId` so they no longer collide with the
 * form's `:idOrAdd`. Legacy mounted both on the same URL shape, which was fine while both used the
 * same chrome, but the migrated catalog page needs Beam layouts that assume the document scrolls
 * and so cannot nest under `GlobalNavLayout`/`ScrollableParentLayout` — see `src/routing/README.md`.
 */
export const taskCatalogRoutes: RouteObject = {
  path: taskCatalogPaths.catalogTasksRoute.path,
  Component: AppShell,
  children: [
    {
      Component: BeamNavbarLayout,
      children: [
        { index: true, Component: TaskCatalogPage },
        { path: taskCatalogPaths.catalogTaskFolderRoute.path, Component: TaskCatalogPage },
      ],
    },
    {
      Component: GlobalNavLayout,
      children: [
        {
          Component: ScrollableParentLayout,
          children: [
            { path: taskCatalogPaths.constraintItemsCatalogRoute.path, Component: ConstraintItemCatalogPage },
            { path: taskCatalogPaths.catalogTaskLaborCostsRoute.path, Component: TaskCatalogLaborCostsPage },
            { path: taskCatalogPaths.catalogTaskRoute.path, Component: TaskCatalogForm },
          ],
        },
      ],
    },
    { path: "*", Component: NotFound },
  ],
};
